<template>
  <generic-modal :modal-key="'exchange_stars'" :has-extra-modal-class="'popup_box op_down modal_cont'"
                 @close="$emit('close')">
    <template slot="content">
      <h1>{{ getTranslations.home_exchange_stars_modal_exchange_your }}</h1>
      <div class="stars_exchange_icons">
        <div class="star_icon"><img src="static/images/stars/stars.png" alt="" class="">
          <span class="stars_count">{{ exchangeStarsPoints }}</span>
          <p>{{ getTranslations.home_exchange_stars_modal_stars }}</p>
        </div>
        <div class="arrow_icon"><img src="static/images/stars/arrow_exchange.png" alt="" class=""></div>
        <div class="points_icon"><img src="static/images/stars/nojoom_logo.png" alt="" class="">
          <span class="stars_count">{{ exchangeStarsPoints }}</span>
          <p>{{ getTranslations.home_exchange_stars_modal_nojoom_stars }}</p>
        </div>
      </div>
      <button type="button" @click.prevent="exchangeStarsMethod">{{ getTranslations.home_exchange_suc_modal_confirm }}
      </button>

    </template>
  </generic-modal>
</template>

<script>
  /* eslint no-console: "off", no-param-reassign: ["error", { "props": false }], no-use-before-define: ["error", { "variables": false }] */
import { mapGetters, mapActions, mapState } from 'vuex';
import GenericModal from '../../sharedcomponents/GenericModal';

export default {
  name: 'exchangeStarsModal',
  components: { GenericModal },
  methods: {
    ...mapActions('profile', [
      'exchangeStars',
      'getUserLoginDetails',
    ]),
    exchangeStarsMethod() {
      this.exchangeStars().then((response) => {
        console.log(response.data.responseEnum);
        if (response.data.responseEnum === 'SERVER_ERROR') {
          this.onError();
        } else {
          this.getUserLoginDetails().then(() => {
            this.onSent();
          });
        }
      });
    },
    onError() {
      this.$emit('openFailureModal');
    },
    onSent() {
      this.$emit('openSuccessModal');
    },
  },
  computed: {
    ...mapGetters('i18n', [
      'getTranslations',
    ]),
    ...mapState('common', [
      'userDetails',
      'exchangeStarsPoints',
    ]),
  },
};
</script>



// WEBPACK FOOTER //
// src/components/home/modals/stars/ExchangeStarsModal.vue